import { useLingui } from '@lingui/react/macro'
import {
  Item,
  ItemActions,
  ItemContent,
  ItemDescription,
  ItemMedia,
  ItemTitle,
} from 'designSystem/components/Item'
import { ImageOff } from 'lucide-react'
import React, { type ReactNode } from 'react'

import { PHOTO_PENDING_HINT } from './photoElections'
import { photoDisplayTitle, type SubjectPhoto } from './types'

export const SubjectPhotoCard: React.FC<{
  photo: SubjectPhoto
  action: ReactNode
}> = ({ photo, action }) => {
  const { t } = useLingui()
  const title = photoDisplayTitle(photo.entry)

  return (
    <Item variant='outline' size='xs'>
      {photo.thumbnailUrl ? (
        <ItemMedia variant='image' align='center' size='lg'>
          <img src={photo.thumbnailUrl} alt={title} />
        </ItemMedia>
      ) : (
        <ItemMedia variant='icon' align='center'>
          <ImageOff />
        </ItemMedia>
      )}
      <ItemContent>
        {photo.pending && (
          <ItemDescription>{t(PHOTO_PENDING_HINT)}</ItemDescription>
        )}
        <ItemTitle title={title}>{title}</ItemTitle>
      </ItemContent>
      <ItemActions variant='trailing'>{action}</ItemActions>
    </Item>
  )
}
